var _defs, _path, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconZoom = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .zoom_a {\n                fill: #fff;\n            }\n\n            .zoom_b {\n                fill: none !important;\n            }\n        "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "zoom_a",
    d: "M26.536,23.712H25.049l-.527-.508A12.257,12.257,0,1,0,23.2,24.521l.508.527v1.487l9.414,9.4,2.806-2.806Zm-11.3,0a8.473,8.473,0,1,1,8.473-8.473A8.462,8.462,0,0,1,15.239,23.712Zm.941-13.18H14.3V14.3H10.532V16.18H14.3v3.766H16.18V16.18h3.766V14.3H16.18Z",
    transform: "translate(2.685 3.056)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "zoom_b",
    width: 44,
    height: 44
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconZoom);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon_zoom.3f938ad2a382c220551afdc493d5fd0b.svg";